import { createModel } from 'hox';
import { useState, useEffect } from 'react';
import { IFullOrderFields, IFullOrderSearch } from './fullOrderTypes';
import useGlobalModel from '@/model/globalModel';
import { useSessionStorageState } from "ahooks";
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { ISearchPage } from '@/types/FmsTypes';
import { fullOrderService } from './fullOrderService';
import { transPgToPagination } from '@/views/base/app/appModel';
import { useScmSaleRoDetailModel } from '../../scmBill/scmSaleRo/scmSaleRoModel';
import { useBmsSaleRoDetailModel } from '../../bmsBill/bmsBillSaleRo/bmsBillSaleRoModel';
import { useVrmSaleRoDetailModel } from '../../vrmBill/vrmBillSaleRo/vrmBillSaleRoModel';
import { forFind } from '@/utils/utils';
import useNavModel from '@/model/navModel';
import { convertRes2Blob } from '@/utils/exportFile';
import { Interface } from 'readline';

export enum FullOrderEnum {
	'purchase',
	'sale',
	'repair',
	'bus',
	'ciRepair',
}
type dictObj = {
	[key: string]: any;
};

export const useFullOrderModel = createModel(function () {
	const {
		user: { shopId, shopCode },
		userBranch,
		setLoadingInfo,
	} = useGlobalModel();
	const { selectedNavId, replaceNav } = useNavModel();
	const { scmTreeSource,ngaTreeSource } = useScmSaleRoDetailModel();
	const { treeSource: bcmTreeSource } = useBmsSaleRoDetailModel();
	const { treeSource: vrmTreeSource } = useVrmSaleRoDetailModel();
	const initSearchParam: IFullOrderFields = {};
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	//查询条件
	const [searchParam, setSearchParam] = useState<IFullOrderFields>(initSearchParam);
	//表格选中行Key值
	const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
	//表格选中的值
	const [selectedRow, setSelectedRow] = useState<IFullOrderFields>({});
	//列表数据源分页参数
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	// 列表数据源
	const [dataSource, setDataSource] = useState<IFullOrderFields[]>([]);
	const [fullOrderStatus, setFullOrderStatus] = useSessionStorageState<FullOrderEnum>("fullOrder.status", FullOrderEnum.purchase);
	const [loading, setLoading] = useState<boolean>(false);
	// 数据字典项
	const [dictData, setDictData] = useState<any[]>([]);
	useEffect(() => {
		if (userBranch === 'scm') {
			setDictData(scmTreeSource);
		} else if (userBranch === 'vrm') {
			setDictData(vrmTreeSource);
		} else if (userBranch === 'bcm') {
			setDictData(bcmTreeSource);
		} else if (userBranch === 'ci') {
			setDictData(vrmTreeSource);
		}else {
			setDictData(ngaTreeSource);
		}
	}, [userBranch]);

	const updateSearchParam = (updateParam: IFullOrderFields) => {
		if (fullOrderStatus != FullOrderEnum.repair) {
			setSearchParam({ ...searchParam, ...updateParam });
		} else {
			if (updateParam.startTime && updateParam.endTime) {
				updateParam = {
					...updateParam,
					createStartTime: updateParam.startTime,
					createEndTime: updateParam.endTime,
				};
			} else {
				updateParam = {
					...updateParam,
					startTime: '',
					endTime: '',
				};
			}
			setSearchParam({ ...searchParam, ...updateParam });
		}
	};

	const resetSearchParam = () => {
		setSearchParam(initSearchParam);
		if (fullOrderStatus === FullOrderEnum.purchase) {
			purchaseLoadData(initPgCfg, {});
		} else if (fullOrderStatus === FullOrderEnum.sale) {
			saleLoadData(initPgCfg, {});
		} else if (fullOrderStatus === FullOrderEnum.repair) {
			repairLoadData(initPgCfg, {});
		} else if (fullOrderStatus === FullOrderEnum.bus) {
			busSaleLoadData(initPgCfg, {});
		}
		setSelectedRowKeys([]);
	};

	const resetParam = () => {
		setSearchParam(initSearchParam);
		setSelectedRowKeys([]);
	};

	// 采购与采退列表
	const purchaseLoadData = async (
		page?: ISearchPage,
		searchValue: IFullOrderSearch = searchParam
	) => {
		setLoading(true);
		const searchParams = {
			...searchValue,
			shopId,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		if (userBranch === 'scm') {
			let { retData } = await fullOrderService.scmPPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		} else if (userBranch === 'vrm') {
			let { retData } = await fullOrderService.vrmPPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		} else if (userBranch === 'bcm') {
			let { retData } = await fullOrderService.bcmPPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
		else if (userBranch === 'ci') {
			let { retData } = await fullOrderService.ciPPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
		// else if (userBranch === 'vrm-nga') {//尼日利亚海外门店
		// 	let { retData } = await fullOrderService.vrmNgaPage(searchParams);
		// 	const { records, ...pg } = retData;
		// 	setPgCfg(transPgToPagination(pg));
		// 	setDataSource(records);
		// 	setLoading(false);
		// }
		else if (userBranch === 'vrm-nga-s') {//云豪商贸
			let { retData } = await fullOrderService.vrmNgaSPuchasePage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
		else if (userBranch === 'vrm-nga-yh') {//云豪商贸（尼）
			let { retData } = await fullOrderService.vrmNgaYhPuchasePage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
	};

	// 销售/退 列表数据
	const saleLoadData = async (page?: ISearchPage, searchValue: IFullOrderSearch = searchParam) => {
		setLoading(true);
		const searchParams = {
			shopId,
			...searchValue,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		if (userBranch === 'scm') {
			let { retData } = await fullOrderService.scmSPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			let newRecords = records.map((item) => {
				return {
					...item,
					salesTypeName: item.saleTypeName,
				};
			});
			setDataSource(newRecords);
			setLoading(false);
		} else if (userBranch === 'vrm') {
			let { retData } = await fullOrderService.vrmSPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		} else if (userBranch === 'bcm') {
			let { retData } = await fullOrderService.bcmSPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
		else if (userBranch === 'ci') {
			let { retData } = await fullOrderService.ciSPage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
		// else if (userBranch === 'vrm-nga') {//尼日利亚海外门店
		// 	let { retData } = await fullOrderService.vrmNgaPage(searchParams);
		// 	const { records, ...pg } = retData;
		// 	setPgCfg(transPgToPagination(pg));
		// 	setDataSource(records);
		// 	setLoading(false);
		// }
		else if (userBranch === 'vrm-nga-s') {//云豪商贸
			let { retData } = await fullOrderService.vrmNgaSSalePage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
		else if (userBranch === 'vrm-nga-yh') {//云豪商贸（尼）
			let { retData } = await fullOrderService.vrmNgaYhSalePage(searchParams);
			const { records, ...pg } = retData;
			setPgCfg(transPgToPagination(pg));
			setDataSource(records);
			setLoading(false);
		}
	};

	// 维修列表数据
	const repairLoadData = async (
		page?: ISearchPage,
		searchValue: IFullOrderSearch = searchParam
	) => {
		setLoading(true);
		const searchParams = {
			...searchValue,
			settlementStartTime: searchValue.settlementStartTime ? searchValue.settlementStartTime.replace(/\s/g, "T") : '',
			settlementEndTime: searchValue.settlementEndTime ? searchValue.settlementEndTime.replace(/\s/g, "T") : '',
			shopId,
			shopCode,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		if (userBranch === 'vrm' || userBranch === 'ci') {
			if (fullOrderStatus == FullOrderEnum.repair) {
				let { retData } = await fullOrderService.vrmRPage(searchParams);
				const { records, ...pg } = retData;
				setPgCfg(transPgToPagination(pg));
				let newRecords = records.map((item) => {
					return {
						...item,
						documentNumber: item.code,
					};
				});
				setDataSource(newRecords);
				setLoading(false);
			}
			else if (fullOrderStatus == FullOrderEnum.ciRepair) {
				let { retData } = await fullOrderService.ciRPage(searchParams);
				const { list, ...pg } = retData;
				setPgCfg(transPgToPagination(pg));
				let newRecords = list.map((item) => {
					return {
						...item,
						documentNumber: item.code || item.documentNumber,
					};
				});
				setDataSource(newRecords);
				setLoading(false);
			}
		}
		else if(userBranch === 'bcm'){
			let { retData } = await fullOrderService.bcmRPage(searchParams);
			const { records, ...pg } = retData;
			let newRecords = records.map((item) => {
				return {
					...item,
					documentNumber: item.code,
					tradeTypeName: '维修',
				};
			});
			setPgCfg(transPgToPagination(pg));
			setDataSource(newRecords);
			setLoading(false);
		}
		// else if(userBranch === 'vrm-nga'){
		// 	let { retData } = await fullOrderService.bcmRPage(searchParams);
		// 	const { records, ...pg } = retData;
		// 	let newRecords = records.map((item) => {
		// 		return {
		// 			...item,
		// 			documentNumber: item.code,
		// 			tradeTypeName: '维修',
		// 		};
		// 	});
		// 	setPgCfg(transPgToPagination(pg));
		// 	setDataSource(newRecords);
		// 	setLoading(false);
		// }
		else if(userBranch === 'vrm-nga-s'){
			let { retData } = await fullOrderService.vrmNgaSMaintainPage(searchParams);
			const { records, ...pg } = retData;
			let newRecords = records.map((item) => {
				return {
					...item,
					documentNumber: item.code,
					tradeTypeName: '维修',
				};
			});
			setPgCfg(transPgToPagination(pg));
			setDataSource(newRecords);
			setLoading(false);
		}
		else if(userBranch === 'vrm-nga-yh'){
			let { retData } = await fullOrderService.vrmNgaYhMaintainPage(searchParams);
			const { records, ...pg } = retData;
			let newRecords = records.map((item) => {
				return {
					...item,
					documentNumber: item.code,
					tradeTypeName: '维修',
				};
			});
			setPgCfg(transPgToPagination(pg));
			setDataSource(newRecords);
			setLoading(false);
		}
	};

	// 公交销售销退列表
	const busSaleLoadData = async (
		page?: ISearchPage,
		searchValue: IFullOrderSearch = searchParam
	) => {
		setLoading(true);
		const searchParams = {
			shopId,
			...searchValue,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		let { retData } = await fullOrderService.bcmBSPage(searchParams);
		const { records, ...pg } = retData;
		setPgCfg(transPgToPagination(pg));
		setDataSource(records);
		setLoading(false);
	};

	//根据code 返回对应的node节点名称
	const getTreeNodeName = (code: string): string => {
		let obj: dictObj = {};
		let findTree: any = forFind(dictData, code, 'code');
		return findTree ? findTree['name'] : '';
	};

	// 采购跳转
	const goPurchaseDetail = (t: string, r: any) => {
		if (userBranch === 'scm') {
			if (r.tradeTypeCode === 'trade-type.purchase') {
				replaceNav(
					selectedNavId,
					'10-3',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'10-4',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		} else if (userBranch === 'vrm') {
			if (r.tradeTypeCode === 'trade-type.purchase') {
				replaceNav(
					selectedNavId,
					'11-3',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'11-4',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		} else if (userBranch === 'bcm') {
			if (r.tradeTypeCode === 'trade-type.purchase') {
				replaceNav(
					selectedNavId,
					'12-3',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'12-4',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		}
		else if (userBranch === 'ci') {
			if (r.tradeTypeCode === 'trade-type.purchase') {
				replaceNav(
					selectedNavId,
					'11-3',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'11-4',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		}
	};

	// 销售跳转
	const goSaleDetail = (t: string, r: any) => {
		if (userBranch === 'scm') {
			if (r.tradeTypeCode === 'trade-type.sale') {
				replaceNav(
					selectedNavId,
					'10-2',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'10-1',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		} else if (userBranch === 'vrm') {
			if (r.tradeTypeCode === 'trade-type.sale') {
				replaceNav(
					selectedNavId,
					'11-2',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'11-1',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		} else if (userBranch === 'bcm') {
			if (r.tradeTypeCode === 'trade-type.sale') {
				replaceNav(
					selectedNavId,
					'12-2',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'12-1',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		} else if (userBranch === 'ci') {
			if (r.tradeTypeCode === 'trade-type.sale') {
				replaceNav(
					selectedNavId,
					"11-2",
					{
						id: t as string,
						mode: "",
						branch: "ci" as string,
						parentInfo: {
							selectedNavId,
						}
					},
					true)
			}
			else {
				replaceNav(
					selectedNavId,
					"11-1",
					{
						id: t as string,
						mode: "",
						branch: "ci" as string,
						parentInfo: {
							selectedNavId,
						}
					},
					true)
			}
		}
	};

	// 维修跳转
	const goRepairDetail = (t: string, r: any) => {
		if (userBranch === 'bcm') {
			replaceNav(
				selectedNavId,
				'12-5',
				{
					id: t,
					mode: '',
					parentInfo: {
						selectedNavId,
					},
				},
				true
			);
		}

		if ((userBranch === 'vrm' || userBranch === 'ci') && fullOrderStatus == FullOrderEnum.repair) {
			if (r.tradeTypeCode === 'trade-type.maintenance') {
				replaceNav(
					selectedNavId,
					'11-7',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			} else {
				replaceNav(
					selectedNavId,
					'11-8',
					{
						id: t,
						mode: '',
						parentInfo: {
							selectedNavId,
						},
					},
					true
				);
			}
		}
		if ((userBranch === 'vrm' || userBranch === 'ci') && fullOrderStatus == FullOrderEnum.ciRepair) {
			if (r.tradeTypeName === '维修') {
				replaceNav(
					selectedNavId,
					"11-5",
					{
						id: t as string,
						mode: "",
						branch: "ci" as string,
						parentInfo: {
							selectedNavId,
						}
					},
					true)
			}
			else {
				replaceNav(
					selectedNavId,
					"11-6",
					{
						id: t as string,
						mode: "",
						branch: "ci" as string,
						parentInfo: {
							selectedNavId,
						}
					},
					true)
			}
		}
	};

	// 公交销售跳转
	const goBusSaleDetail = (t: string, r: any) => {
		if (r.tradeTypeCode === 'trade-type.transit-sale') {
			replaceNav(
				selectedNavId,
				'12-7',
				{
					id: t,
					mode: '',
					parentInfo: {
						selectedNavId,
					},
				},
				true
			);
		} else {
			replaceNav(
				selectedNavId,
				'12-6',
				{
					id: t,
					mode: '',
					parentInfo: {
						selectedNavId,
					},
				},
				true
			);
		}
	};

	// 导出
	const fullOrderExport = async (
		str: FullOrderEnum,
		page?: ISearchPage,
		searchValue: IFullOrderSearch = searchParam
	) => {
		setLoadingInfo({ loadingVisible: true, txt: '快速导出中,请稍等...' });
		try {
			let type = '';
			if (str === FullOrderEnum.purchase) {
				type = 'puchase';
			} else if (str === FullOrderEnum.sale) {
				type = 'sale';
			} else if (str === FullOrderEnum.repair || str === FullOrderEnum.ciRepair) {
				type = 'maintain';
			} else if (str === FullOrderEnum.bus) {
				type = 'busSale';
			}

			let data: any = {
				branch: userBranch,
				shopId,
				// code: selectedRowKeys.join(),
				id:selectedRowKeys.join(),
				...searchValue,
				pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
				pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
				type,
			};
			let result;
			let scmTypeList = [FullOrderEnum.sale, FullOrderEnum.purchase]
			let vrmTypeList = [FullOrderEnum.sale, FullOrderEnum.repair, FullOrderEnum.purchase]
			// if(userBranch === "vrm" && type === "sale"){
			// 	data.documentNumber = selectedRowKeys.join()
			// }else{
			// 	data.code = selectedRowKeys.join()
			// }
			if (userBranch === "scm") {
				if (type === "sale") {
					result = await fullOrderService.saleDetailExport(data);
				} else {
					result = await fullOrderService.purchaseDetailExport(data);
				}
			}
			else if (userBranch === "bcm") {
				if (type === "sale") {
					result = await fullOrderService.bcmSaleDetailExport(data);
				} else if (type === "puchase") {
					result = await fullOrderService.bcmPurchaseDetailExport(data);
				} else if (type === "maintain") {
					result = await fullOrderService.bcmRepairDetailExport({
						...data,
						settlementStartTime: searchValue.settlementStartTime ? searchValue.settlementStartTime.replace(/\s/g, "T") : '',
						settlementEndTime: searchValue.settlementEndTime ? searchValue.settlementEndTime.replace(/\s/g, "T") : '',
					});
				} else {
					result = await fullOrderService.bcmTransitDetailExport(data);
				}
			}





			// else if (userBranch === "vrm-nga") {
			// 	if (type === "sale") {
			// 		result = await fullOrderService.bcmSaleDetailExport(data);
			// 	} else if (type === "puchase") {
			// 		result = await fullOrderService.bcmPurchaseDetailExport(data);
			// 	} else if (type === "maintain") {
			// 		result = await fullOrderService.bcmRepairDetailExport({
			// 			...data,
			// 			settlementStartTime: searchValue.settlementStartTime ? searchValue.settlementStartTime.replace(/\s/g, "T") : '',
			// 			settlementEndTime: searchValue.settlementEndTime ? searchValue.settlementEndTime.replace(/\s/g, "T") : '',
			// 		});
			// 	} else {
			// 		result = await fullOrderService.bcmTransitDetailExport(data);
			// 	}
			// }
			else if (userBranch === "vrm-nga-s") {
				if (type === "sale") {
					result = await fullOrderService.vrmNgaSSaleDetailExport(data);
				} else if (type === "puchase") {
					result = await fullOrderService.vrmNgaSPuchaseDetailExport(data);
				} else {
					result = await fullOrderService.vrmNgaSMaintainDetailExport({
						...data,
						settlementStartTime: searchValue.settlementStartTime ? searchValue.settlementStartTime.replace(/\s/g, "T") : '',
						settlementEndTime: searchValue.settlementEndTime ? searchValue.settlementEndTime.replace(/\s/g, "T") : '',
					});
				} 
			}
			else if (userBranch === "vrm-nga-yh") {
				if (type === "sale") {
					result = await fullOrderService.vrmNgaYhSaleDetailExport(data);
				} else if (type === "puchase") {
					result = await fullOrderService.vrmNgaYhPuchaseDetailExport(data);
				} else {
					result = await fullOrderService.vrmNgaYhMaintainDetailExport({
						...data,
						settlementStartTime: searchValue.settlementStartTime ? searchValue.settlementStartTime.replace(/\s/g, "T") : '',
						settlementEndTime: searchValue.settlementEndTime ? searchValue.settlementEndTime.replace(/\s/g, "T") : '',
					});
				} 
			}




			
			else if (userBranch === "vrm") {
				if (type === "sale") {
					data.documentNumber = data.code
					delete data.code
					result = await fullOrderService.vrmSaleDetailExport(data);
				} else if (type === "puchase") {
					result = await fullOrderService.vrmPurchaseDetailExport(data);
				} else {
					if (fullOrderStatus == FullOrderEnum.repair) {
						result = await fullOrderService.vrmRepairDetailExport({
							...data,
							settlementStartTime: searchValue.settlementStartTime ? searchValue.settlementStartTime.replace(/\s/g, "T") : '',
							settlementEndTime: searchValue.settlementEndTime ? searchValue.settlementEndTime.replace(/\s/g, "T") : '',
						});
					}
					else {
						result = await fullOrderService.ciRepairExport(data);
					}
				}
			}
			else if (userBranch === "ci") {
				if (type === "sale") {
					result = await fullOrderService.ciSaleExport(data);
				}
				else if (type === "maintain") {
					if (fullOrderStatus == FullOrderEnum.repair) {
						result = await fullOrderService.vrmRepairDetailExport({
							...data,
							settlementStartTime: searchValue.settlementStartTime ? searchValue.settlementStartTime.replace(/\s/g, "T") : '',
							settlementEndTime: searchValue.settlementEndTime ? searchValue.settlementEndTime.replace(/\s/g, "T") : '',
						});
					}
					else {
						result = await fullOrderService.ciRepairExport(data);
					}
				}
				else {
					result = await fullOrderService.ciPurchaseExport(data);
				}
			}
			else {
				result = await fullOrderService.detailExport(data);
			}
			result && setLoadingInfo({ loadingVisible: false, txt: '' });
			convertRes2Blob(result);
		} catch {
			setLoadingInfo({ loadingVisible: false, txt: '' });
		}
	};


	//对账单导出
	const fullOrderSimplExport = async (
		str: FullOrderEnum,
		page?: ISearchPage,
		searchValue: IFullOrderSearch = searchParam
	) => {
		setLoadingInfo({ loadingVisible: true, txt: '快速导出中,请稍等...' });
		try {
			let type = '';
			if (str === FullOrderEnum.purchase) {
				type = 'puchase';
			} else if (str === FullOrderEnum.sale) {
				type = 'sale';
			} else if (str === FullOrderEnum.repair) {
				type = 'maintain';
			} else if (str === FullOrderEnum.bus) {
				type = 'busSale';
			}

			let data: any = {
				branch: userBranch,
				shopId,
				...searchValue,
				pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
				pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
				type,
			};
			let result;
			if (userBranch === "scm") {
				result = await fullOrderService.scm2SimplificationExport(data);
			}
			result && setLoadingInfo({ loadingVisible: false, txt: '' });
			result && convertRes2Blob(result);
		} catch {
			setLoadingInfo({ loadingVisible: false, txt: '' });
		}
	};


	return {
		/* field */
		initPgCfg,
		searchParam,
		selectedRowKeys,
		selectedRow,
		pgCfg,
		dataSource,
		fullOrderStatus,
		loading,
		/**method */
		setSearchParam,
		setSelectedRowKeys,
		setSelectedRow,
		setPgCfg,
		updateSearchParam,
		purchaseLoadData,
		resetSearchParam,
		getTreeNodeName,
		saleLoadData,
		repairLoadData,
		busSaleLoadData,
		setFullOrderStatus,
		setDataSource,
		goPurchaseDetail,
		goSaleDetail,
		goRepairDetail,
		goBusSaleDetail,
		fullOrderExport,
		setLoading,
		resetParam,
		fullOrderSimplExport
	};
});
